import React from "react";
import Box from '@mui/material/Box';

interface TabPanelProps {
  setTabValueEventCallBack: any;
  label: string;
  tabs: string[];
  tab: string;
}

const SimpleTabHeaderComponent = (props: TabPanelProps) => {
  const [tabValue, setTabValue] = React.useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    props.setTabValueEventCallBack(newValue);
    setTabValue(newValue);
  };

  const handleTabChange2 = (newValue: number) => {
    props.setTabValueEventCallBack(newValue);
    setTabValue(newValue);
  };

  function setTabIndex(index: number) {
    return {
      id: `${props.tab}-tab-${index}`,
      'aria-controls': `${props.tab}-tabpanel-${index}`,
    };
  }

  const styleDark = {
    "color": "silver !important ",
    backgroundColor: "#333 !important"
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <nav>
        <div className="nav nav-tabs" id="nav-tab" role="tablist">
          {props.tabs.map((tab, index) => (
            <button
              onClick={() => handleTabChange2(index)}
              className={`nav-link ${(index==0 ? 'active' : '')}`}
              style={styleDark}
              key={`nav-${props.tab}${index}-tab`}
              id={`nav-${props.tab}${index}-tab`}
              data-bs-toggle="tab"
              data-bs-target={`#nav-${props.tab}${index}`}
              type="button"
              role="tab"
              aria-controls={`nav-${props.tab}${index}`}
            >
                {tab}
                <span key={`nav-${props.tab}-tab${index}`} id={`nav-${props.tab}-tab${index}`}></span>
            </button>
          ))}
        </div>
      </nav>
    </Box>
  );
}

export default SimpleTabHeaderComponent;